// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"wl","editButton":"wm","formClass":"wn","rowClass":"wo","columnClass":"wp","inputClass":"wq","email":"wr","mobile":"ws","cancelButton":"wt","submitButton":"wu"};